import CaseLayout from '../../layouts/CaseLayout/CaseLayout'
import Script from '../../components/Script/Script'

const ScriptPage = () => {
  return (
    <CaseLayout floatingHeader={true} alwaysShowNav={false}>
      <Script />
    </CaseLayout>
  )
}

export default ScriptPage
